var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab", [
    _c(
      "div",
      { staticClass: "lend" },
      [
        _c("yqg-md-preview", {
          attrs: {
            "md-text": _vm.$t("mdText", [
              _vm.yqdContact.email,
              _vm.finContact.email,
            ]),
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }